import { render, staticRenderFns } from "./EzLoadMore.vue?vue&type=template&id=08c3b2b6&"
import script from "./EzLoadMore.vue?vue&type=script&lang=js&"
export * from "./EzLoadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports